module.exports = __webpack_public_path__ + "static/media/orange-pencil.e47af2f3.svg";